/* eslint-disable */
import React from "react"
import { Helmet } from "react-helmet-async"

// Components
import { BlankDocuments } from "../../UI/Templates"

const TermsConditions = () => (
  <>
    <Helmet>
      <title>Terms &amp; Conditions</title>
    </Helmet>
    <BlankDocuments title="Terms & Conditions">
      <div
        className="WordSection1"
        link="#467886"
        vlink="#96607D"
        style={{ tabInterval: "36.0pt", wordWrap: "break-word" }}
      >
        <p className="MsoNormal">
          <b>Between</b>
        </p>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <li className="MsoNormal" style={{ msoList: "l13 level1 lfo1", tabStops: "list 36.0pt" }}>
            4C Platform.com Limited (“<b>the Provider</b>”), a company incorporated in England and
            Wales under company number 7377957 and with registered address Unit 5. Hercules Court,
            Lakeside Business Park, Broadway Lane, South Cerney, Cirencester, Gloucestershire, GL7
            5XZ.
          </li>
          <li className="MsoNormal" style={{ msoList: "l13 level1 lfo1", tabStops: "list 36.0pt" }}>
            [ ] (“<b>the Introducer</b>”).
          </li>
        </ol>
        <p className="MsoNormal">
          <b>Whereas</b>
        </p>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <li
            className="MsoNormal"
            style={{
              color: "black",
              msoThemecolor: "text1",
              msoList: "l14 level1 lfo2",
              tabStops: "list 36.0pt"
            }}
          >
            <span style={{ color: "windowtext" }}>
              The Provider operates an online portal which can be used to introduce{" "}
            </span>
            customers wanting to obtain insurance to insurers;
          </li>
          <li
            className="MsoNormal"
            style={{
              color: "black",
              msoThemecolor: "text1",
              msoList: "l14 level1 lfo2",
              tabStops: "list 36.0pt"
            }}
          >
            The Provider has entered into an appointed representative agreement to perform the
            activities under this Agreement. The authorised representative that the Provider will be
            operating under is Health and Protection Solutions Limited (trading as “Everywhen
            Benefits”), a company registered in England and Wales (registered number 04907859) and
            its registered office is at West Park House, 23 Cumberland Place, Southampton, United
            Kingdom, SO15 2BB. Financial Conduct Authority reference number: 308189.
          </li>
          <li
            className="MsoNormal"
            style={{
              color: "black",
              msoThemecolor: "text1",
              msoList: "l14 level1 lfo2",
              tabStops: "list 36.0pt"
            }}
          >
            <span style={{ msoSpacerun: "yes" }}>&nbsp;</span>The Introducer is an insurance
            intermediary that introduces customers wanting to obtain insurance to insurers. The
            Introducer wishes to use the Provider's portal to facilitate such introductions, and to
            introduce customers to insurers.
          </li>
        </ol>
        <p className="MsoNormal">
          <span style={{ color: "black", msoThemecolor: "text1" }}>
            It is hereby agreed as follows:
          </span>
        </p>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>DEFINITIONS AND INTERPRETATION</b>
          </li>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo3", tabStops: "list 72.0pt" }}
            >
              In this Agreement the following words shall have the meaning set out below unless
              otherwise stated to the contrary;
            </li>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Agreement”</b>&nbsp;means this agreement between the Provider and the
                Introducer, and includes the schedules to the Agreement;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Confidential Information”</b>&nbsp;means any information and/or material
                relating to the business, including but not limited to affairs, finances, trade
                secrets, systems, processes, technical information, know-how, operational documents
                (including the terms and details of this Agreement) and/or methods of operation of a
                party which are disclosed by that party to another in connection with the operation
                of this Agreement (whether disclosed electronically, orally, or in writing, at any
                time whether before or after the date of this agreement and whether or not such
                information is expressly stated to be confidential or marked as such);
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Customer”</b>&nbsp;means those individuals, partnerships or companies that wish
                to obtain insurance;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Customer Information”</b>&nbsp;means the personal data of a Customer entered or
                placed on the Portal;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Data Protection Laws”</b>&nbsp;has the meaning given to it in Schedule 2 – Data
                Processing;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Financial Services Legislation”</b>&nbsp;means the Financial Services and
                Markets Act 2000, any subordinate legislation made under that Act, any Rules and
                Guidance made under that Act (including any Rules and Guidance contained in the
                Financial Conduct Authority Handbook), and any other obligation or requirement
                imposed by virtue of being authorised and regulated by the Financial Conduct
                Authority, and includes any legislation, rules, guidance, requirements and
                obligations which repeals, replaces and/or supersedes the same;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Information”</b>&nbsp;means the data entered or placed onto the Portal by the
                Introducer and other Users and/or Insurers, including any Customer Information or
                any Introducer Information;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Insurance Introductions”</b>&nbsp;means that process of obtaining insurance on
                behalf of a Customer from an Insurer. It includes without limitation the obtaining
                of a quote, the sending of Customer Information to the Insurer via the Portal, and
                the obtaining of a contract of insurance;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Insurer”</b>&nbsp;means insurance companies who are, or who are seeking to be,
                introduced to Customers via the Portal;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Intellectual Property Rights”</b>&nbsp;means all vested, contingent and future
                intellectual property rights including but not limited to copyright (including
                copyright in software), database rights, moral rights, trade marks, patents, know-
                how, design rights (including unregistered rights, registered rights and
                applications thereof), inventions, get-up, domain names, metatags, applications for
                the protection and registration of these rights (including renewals and extensions
                thereof), and any goodwill associated with the intellectual property as well as
                rights under licences, consents, orders, statute or otherwise, whether existing in
                any part of the world and whether now known or in the future created to which the
                party may be entitled;
              </li>
              <li
                className="MsoNormal"
                style={{
                  color: "black",
                  msoThemecolor: "text1",
                  msoList: "l12 level3 lfo3",
                  tabStops: "list 108.0pt"
                }}
              >
                <b>
                  <span style={{ color: "windowtext" }}>"Introducer Information”</span>
                </b>
                <span style={{ color: "windowtext" }}>
                  &nbsp;means any information of whatever nature, including Customer Information,
                  entered or placed on the{" "}
                </span>
                Portal by the Introducer;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Licence”</b>&nbsp;means the licence granted pursuant to clause 3 below on the
                terms set out in Schedule 1 to this Agreement, as amended pursuant to the terms of
                Schedule 1 from time to time;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Network Access Agreement”</b>&nbsp;means an agreement between the Provider and a
                network entered into at the request of an Introducer which allows the network access
                to the Portal to enable the network to audit the activities of the Introducer (to
                include, without limitation, the Introducer's compliance with any Financial Services
                Legislation and/or with the terms of any agreement that the Introducer may have with
                the network);
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Personal Data”</b>&nbsp;has the meaning given to it in Schedule 2 – Data
                Processing;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"Portal”</b>&nbsp;means the electronic platform operated by the Provider by which
                Customers can be introduced to Insurers;
              </li>
              <li
                className="MsoNormal"
                style={{
                  color: "black",
                  msoThemecolor: "text1",
                  msoList: "l12 level3 lfo3",
                  tabStops: "list 108.0pt"
                }}
              >
                <b>"Schedules”</b>&nbsp;means the Schedules to this Agreement;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo3", tabStops: "list 108.0pt" }}
              >
                <b>"User”</b>&nbsp;means another introducer that uses the Portal, other than the
                Introducer;
              </li>
            </ol>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo3", tabStops: "list 72.0pt" }}
            >
              In this Agreement unless the context requires otherwise:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <ol style={{ marginTop: "0cm" }} start={2} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                Words importing any gender include every gender;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                Words importing the singular number include the plural number and vice versa;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                Words importing persons include firms, companies and corporations and vice versa;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                References to numbered clauses are references to the relevant clause in this
                Agreement;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                Reference in any Schedule to numbered paragraphs relate to the numbered paragraphs
                of that Schedule;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                The headings to the clauses, Schedules and paragraphs of this Agreement will not
                affect the interpretation;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                Any reference to an enactment includes reference to that enactment as amended or
                replaced from time to time and to any subordinate legislation or byelaw made under
                that enactment;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                Any obligation on any party to do or omit to do anything is to include an obligation
                not to allow that thing to be done or omitted to be done;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                Any obligation on any party to do or omit to do anything is also an obligation on
                that party to ensure that its employees, servants or agents do or omit to do that
                thing to be done or omitted to be done;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                Any party who agrees to do something will be deemed to fulfil that obligation if
                that party procures that it is done;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo4", tabStops: "list 108.0pt" }}
              >
                Any reference to loss and damage means loss or damage of whatever nature, including
                without limitation losses, costs (including legal costs), charges, damages,
                expenses, loss of profits, loss of data, loss of income, loss or damage to property,
                and loss of chance, including pure economic, compensatory, direct, indirect, or
                consequential loss and damage;
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <ol style={{ marginTop: "0cm" }} start={3} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo3", tabStops: "list 72.0pt" }}
            >
              In the case of conflict or ambiguity between any provision contained in the body of
              this Agreement and any provision contained in any Schedule, the provision in the body
              of this Agreement shall take precedence.
            </li>
          </ol>
          <li
            className="MsoNormal"
            style={{
              color: "black",
              msoThemecolor: "text1",
              msoList: "l12 level1 lfo3",
              tabStops: "list 36.0pt"
            }}
          >
            <b>AUTHORISATIONS</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={2} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo5", tabStops: "list 72.0pt" }}
            >
              The Introducer shall at all times hold and maintain all necessary regulatory
              approvals, authorisations and permissions, including without limitation under
              Financial Services Legislation, for the activities which it proposes to carry out
              under this Agreement;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo5", tabStops: "list 72.0pt" }}
            >
              The Introducer shall ensure that any of its employees, servants or agents who access
              the Portal or who act on behalf of the Introducer in relation to this Agreement at all
              time hold and maintain all necessary regulatory approvals, authorisations and
              permissions, including without limitation under Financial Services Legislation, that
              are required for any activity that that employee, servant or agent carries on in
              relation to this Agreement;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo5", tabStops: "list 72.0pt" }}
            >
              If the Introducer has entered into an appointed representative agreement with an
              authorised person to enable it to carry out the activities which it proposes to carry
              out under this Agreement without it needing to be itself directly authorised by the
              Financial Conduct Authority this shall satisfy the Introducer's obligations under
              subclause 2.2, provided that:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={2} type={1}>
          <ol style={{ marginTop: "0cm" }} start={3} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo6", tabStops: "list 108.0pt" }}
              >
                The Introducer remains an appointed representative throughout the duration of the
                Agreement;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo6", tabStops: "list 108.0pt" }}
              >
                The Introducer makes the authorised person fully aware of the Introducer's intention
                to use the Portal and what that entails and the authorised person consents to the
                same;
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={2} type={1}>
          <ol style={{ marginTop: "0cm" }} start={4} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo5", tabStops: "list 72.0pt" }}
            >
              In the event that the Introducer ceases to have all necessary regulatory approvals,
              authorisations and permissions, or ceases to be an appointed representative as
              described in subclause 2.2 above, the Introducer shall immediately cease to use the
              Portal until such time as the Introducer again obtains such approvals, authorisations
              and permissions, or again becomes such an appointed representative.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={3} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>USE OF THE PORTAL</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={3} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo7", tabStops: "list 72.0pt" }}
            >
              <span style={{ msoBidiFontSize: "10.0pt", lineHeight: "115%" }}>
                The Provider grants to the Introducer a limited, non-exclusive, non-transferable,
                non-sub-licensable right on the terms and conditions set out in Schedule 1 to this
                Agreement, to permit the Introducer to access and use the Portal
              </span>
              ;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo7", tabStops: "list 72.0pt" }}
            >
              The Provider may, but is not under an obligation to, provide assistance via the Portal
              to Introducers and/or Insurers on complying with the Introducer's and/or Insurers'
              obligations under Financial Services Legislation, for example by the Portal generating
              documents that are designed to comply with Financial Services Legislation. However,
              the Portal is not a compliance platform, and the Provider is not providing any
              warranty, guarantee or assurance that any Introduction made via the Portal or
              documentation generated by the Portal shall be compliant with Financial Services
              Legislation. It shall in all cases be the responsibility of the Introducer and/or the
              Insurer to:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={3} type={1}>
          <ol style={{ marginTop: "0cm" }} start={2} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo8", tabStops: "list 108.0pt" }}
              >
                ensure that they are compliant with Financial Services Legislation;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo8", tabStops: "list 108.0pt" }}
              >
                satisfy themselves that any documentation generated by the Portal or other
                assistance is compliant with Financial Services Legislation.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={3} type={1}>
          <ol style={{ marginTop: "0cm" }} start={3} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo7", tabStops: "list 72.0pt" }}
            >
              The Introducer shall use the Portal to perform the direct introduction of a Customer
              pursuant to subclause 5 below.{" "}
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo7", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not use the Portal for any purpose other than provided for by
              subclause 3.3 above.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo7", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not allow any Customer to access or use the Portal.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo7", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not use the Portal in respect of any Customer if the Provider's
              dealings with that Customer are not subject to the Financial Services Legislation of
              the United Kingdom.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo7", tabStops: "list 72.0pt" }}
            >
              Where the Introducer is a member of a network and the network's consent is needed for
              the use of the Portal the Introducer shall ensure that it has such consent before
              using the Portal. Upon request by an Introducer the Provider may, in its absolute
              discretion, agree to enter into a Network Access Agreement with that network. Once a
              Network Access Agreement is entered into the continuance of the Network Access
              Agreement is at the discretion of the Provider and the Introducer shall have no right
              to have the Network Access Agreement terminated.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo7", tabStops: "list 72.0pt" }}
            >
              The use by the Introducer of the Portal is at the Provider's absolute discretion. The
              Provider may, in its absolute discretion and with or without reason and/or notice,
              refuse to allow the Introducer access to the Portal, either permanently or
              indefinitely and/or may suspend or terminate the Licence.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={4} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>GOOD FAITH</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={4} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo10", tabStops: "list 72.0pt" }}
            >
              The Introducer shall use the Portal in good faith. In particular and without
              limitation the Introducer shall not seek to make an Insurance Introduction otherwise
              than through the Portal if that Insurance Introduction results from, or has otherwise
              been influenced or affected by, any knowledge or information gained from the
              Introducer's use of the Portal.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo10", tabStops: "list 72.0pt" }}
            >
              Upon request by the Provider the Introducer shall provide such details as are
              reasonably requested by the Provider of any insurance policies placed with all or any
              particular Insurer(s), whether or not such policies were placed through or as a result
              of the Portal, for the purpose of the Provider ensuring that the Introducer is
              complying with subclause 4.1 above.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo10", tabStops: "list 72.0pt" }}
            >
              The Introducer shall indemnify the Provider against any and all loss and damage
              incurred by them as a result of the Introducer failing to comply with this clause 4.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={5} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>DIRECT INTRODUCTION TO INSURER</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={5} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo11", tabStops: "list 72.0pt" }}
            >
              The Introducer may use the Portal to send Customer Information to an Insurer for the
              purpose of Insurance Introductions.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo11", tabStops: "list 72.0pt" }}
            >
              The act by which the Introducer can send Customer Information to an Insurer will be
              described in the Portal.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo11", tabStops: "list 72.0pt" }}
            >
              The ability of the Introducer to send Customer Information to any particular Insurer
              is at the discretion of both the Provider and the Insurer. The Provider does not
              provide any warranty or guarantee that the Introducer will be able to send Customer
              Information to any particular Insurer, and the Provider may withdraw or limit the
              ability of the Introducer to send Customer Information to a particular Insurer (or to
              any or all of them) at any time.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={6} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>DISCLOSURE OF COMMISSIONS</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={6} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo19", tabStops: "list 72.0pt" }}
            >
              The Introducer shall ensure that it complies with all legal and/or regulatory
              obligations to disclose to Customers the Introducer's commission received under this
              Agreement and/or received from any Insurer as a result of an introduction made using
              the Portal.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={7} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>REGULATORY AND LEGAL REQUIREMENTS</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={7} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo20", tabStops: "list 72.0pt" }}
            >
              The Introducer shall at all material times comply with all legal and regulatory
              requirements, including under Financial Services Legislation, that it is subject to,
              including but without limitation by virtue of entering into this Agreement or using
              the Portal.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo20", tabStops: "list 72.0pt" }}
            >
              Nothing in this Agreement shall require any of the Introducer or the Provider to act
              in any way that is contrary to any legal and regulatory requirements that it may have,
              including under Financial Services Legislation, save that this clause may not be
              relied upon to allow any party to avoid the payment of any money to another party that
              would otherwise be due under this Agreement.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo20", tabStops: "list 72.0pt" }}
            >
              By entering into this Agreement the Introducer represents and warrants to the Provider
              that it is not aware of any material fact that:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={7} type={1}>
          <ol style={{ marginTop: "0cm" }} start={3} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo21", tabStops: "list 108.0pt" }}
              >
                Might make it illegal, contrary to any legal or regulatory requirement (including
                under Financial Services Legislation) or otherwise make it unsuitable for the
                Introducer or the Provider to enter into this Agreement;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo21", tabStops: "list 108.0pt" }}
              >
                Would place it or the Provider in breach of this Agreement.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={7} type={1}>
          <ol style={{ marginTop: "0cm" }} start={4} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo20", tabStops: "list 72.0pt" }}
            >
              The Introducer shall immediately inform the Provider in writing on becoming aware of
              any fact that would, if it had existed at the time of entry into this Agreement, have
              fallen within subclause 7.3 above.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo20", tabStops: "list 72.0pt" }}
            >
              Should the Introducer be under any doubt as to whether or not a fact is material for
              the purposes of this clause it shall treat that fact as material.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo20", tabStops: "list 72.0pt" }}
            >
              No party shall accept, offer or facilitate payment, consideration or any other benefit
              which constitutes an illegal or corrupt practice contrary to any applicable
              anti-bribery legislation.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo20", tabStops: "list 72.0pt" }}
            >
              All parties shall maintain on an on-going basis appropriate systems, procedures and
              controls designed to prevent the risk of bribery, money laundering and other financial
              crime.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo20", tabStops: "list 72.0pt" }}
            >
              The Introducer shall fully co-operate with any enquiries made by the Provider to
              ensure that the Introducer is complying with this clause, such co-operation to include
              the provision of information when requested, the answering of such questions as the
              Provider deems appropriate, and co-operating with any audit that the Provider deems
              necessary or desirable. The Provider shall be entitled to take copies, at the
              Introducer's expense, of any information or documentation provided under this clause.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo20", tabStops: "list 72.0pt" }}
            >
              For the avoidance of doubt nothing in this clause shall be taken to place any
              obligation on the Provider to ensure that the Introducer is complying with its duties
              under this Agreement and/or under any legal and regulatory requirements or to make the
              Provider responsible for such compliance.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={8} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>RECORDS</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={8} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo22", tabStops: "list 72.0pt" }}
            >
              The Introducer shall maintain such records of its use of the Portal, including which
              Customer Information is entered on the Portal and its entitlement to commission, as is
              required to comply with its legal and regulatory responsibilities, including without
              limitation its obligations under Financial Services Legislation.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={9} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>RESPONSIBILITY FOR INFORMATION</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={9} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo23", tabStops: "list 72.0pt" }}
            >
              The Introducer shall enter all Introducer Information on the Portal accurately and
              completely. The Provider shall not have any responsibility to verify the accuracy or
              the completeness of Introducer Information.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo23", tabStops: "list 72.0pt" }}
            >
              The Provider accepts no liability whatsoever for any loss or damage, howsoever caused,
              suffered by the Introducer as a result of the Introducer failing to enter Introducer
              Information accurately or completely on the Portal.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo23", tabStops: "list 72.0pt" }}
            >
              The Provider provides access to Information on the Portal which it believes to be
              reliable and accurate at its date of publication. The Provider does not make any
              independent verification of Information. The Introducer accepts and agrees that access
              to and use of the Information is entirely at the Introducer's and/or Customer's own
              risk and the Introducer shall ensure that any Customer accepts and agrees to this
              risk.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>CONFIDENTIALITY</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo24", tabStops: "list 72.0pt" }}
            >
              Subject to subclause 10.4 below no party shall at any time after the date of this
              Agreement:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo25", tabStops: "list 108.0pt" }}
              >
                Divulge or communicate to any person, company, business entity or other
                organisation;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo25", tabStops: "list 108.0pt" }}
              >
                Use for its own purposes or for any purposes other than those of another party; or
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo25", tabStops: "list 108.0pt" }}
              >
                Through any failure to exercise due care and diligence, cause any unauthorised
                disclosure of any Confidential Information of the other party.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <ol style={{ marginTop: "0cm" }} start={2} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo24", tabStops: "list 72.0pt" }}
            >
              Subject to subclause 10.4 each party shall protect any Confidential Information of the
              other party with the same degree of care as it employs with regard to its own
              Confidential Information of a like nature and in any event in accordance with best
              current commercial security practices.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo24", tabStops: "list 72.0pt" }}
            >
              The restrictions in subclauses 10.1 and 10.2 shall cease to apply to any information
              which shall become available to the public generally otherwise than through a breach
              of a duty of confidentiality owed to another party.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo24", tabStops: "list 72.0pt" }}
            >
              The restrictions in subclauses 10.1 and 10.2 shall not apply to:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <ol style={{ marginTop: "0cm" }} start={4} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo26", tabStops: "list 108.0pt" }}
              >
                Any information which was already available to the public generally otherwise than
                through a breach of a duty of confidentiality owed to another party;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo26", tabStops: "list 108.0pt" }}
              >
                Any act done with the consent of the party who's information is confidential;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo26", tabStops: "list 108.0pt" }}
              >
                Any divulgence or communication to an employee, servant or agent of the party who
                needs to know the Confidential Information, provided that it is made clear that the
                divulgence or communication is confidential and that the employee, servant or agent
                owes a duty of care in respect of the divulgence or communication;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo26", tabStops: "list 108.0pt" }}
              >
                Any divulgence or communication to a party's subsidiary, holding company or
                subsidiary of its holding companies (within the meaning of section 1159 of the
                Companies Act 2006 as amended) provided that the company to which disclosure is made
                is bound by the provisions of this clause.
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo26", tabStops: "list 108.0pt" }}
              >
                Any disclosure of Confidential Information which is required in the normal course of
                acting in accordance with that party's business.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <ol style={{ marginTop: "0cm" }} start={5} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo24", tabStops: "list 72.0pt" }}
            >
              No party shall be restricted from disclosing the Confidential Information or any part
              of it pursuant to a judicial or other lawful government order, or regulatory
              requirement or other legal requirement including under Financial Services Legislation,
              but only to the extent required by such order/requirement and subject to the party
              obliged to comply with such order/requirement giving the other parties as much notice
              of the terms of the order/requirement as may be reasonably practicable or lawful.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo24", tabStops: "list 72.0pt" }}
            >
              If any party becomes aware of a breach of confidence by any person to whom it
              discloses Confidential Information it shall promptly notify the other parties and
              shall give any party all reasonable assistance in connection with proceedings which
              any party shall instigate for breach of confidence.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={11} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>DATA PROTECTION</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={11} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo27", tabStops: "list 72.0pt" }}
            >
              The Provider and Introducer agree and acknowledge that certain personal data may be
              processed by the parties in the performance or receipt of the services, as applicable.
              Where a party processes Personal Data in the exercise of its rights and performances
              of its obligations under this Agreement, it shall comply with Schedule 2 - Data
              Processing.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo27", tabStops: "list 72.0pt" }}
            >
              Each party shall comply with Data Protection Laws. In particular, the Introducer
              warrants that it has duly notified the Information Commissioner of its processing of
              Personal Data, and the Introducer shall supply a copy of such notification to the
              Provider on request.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo27", tabStops: "list 72.0pt" }}
            >
              The Introducer acknowledges and agrees that the Provider will retain and process
              Personal Data:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={11} type={1}>
          <ol style={{ marginTop: "0cm" }} start={3} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo28", tabStops: "list 108.0pt" }}
              >
                Of the Introducer, employees or agents of the Introducer and of Customers for the
                purpose of administration of the Portal and maintaining records;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo28", tabStops: "list 108.0pt" }}
              >
                Of the Introducer and/or (if applicable) directors of the Introducer for the purpose
                of assessing the financial standing of the Introducer and/or directors of the
                Introducer with credit reference agencies;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo28", tabStops: "list 108.0pt" }}
              >
                Of Customers for the purpose of obtaining and providing a response to requests for a
                quote from an Insurer.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={11} type={1}>
          <ol style={{ marginTop: "0cm" }} start={4} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo27", tabStops: "list 72.0pt" }}
            >
              The Introducer acknowledge and agrees that the Provider will hold information about
              the Introducer and Customers in electronic form.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo27", tabStops: "list 72.0pt" }}
            >
              The Provider may take Information from the Portal, including Introducer Information
              and/or Customer Information, anonymise it to remove any personal data, and use that
              anonymised information for its own internal business purposes, for example for
              research purposes, business development, and/or statistical analysis. The Provider may
              share such anonymised information and/or the results of its use of that information
              with any other member of the Provider's corporate group or an associated company.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo27", tabStops: "list 72.0pt" }}
            >
              The Introducer shall ensure that it has in each case obtained all necessary consents
              in writing, from Customers or otherwise, under Data Protection Law to permit the
              Provider to process Personal Data as set out above and as set out in the Provider's
              privacy policy published on their websites, and the Introducer shall provide copies of
              such consents to the Provider on request;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo27", tabStops: "list 72.0pt" }}
            >
              Each party agrees to use all reasonable endeavours to assist each other to comply with
              any obligations imposed on them by Data Protection Laws, including the obligation to
              comply with any subject access request.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo27", tabStops: "list 72.0pt" }}
            >
              Each party shall operate reasonably adequate procedures designed to ensure compliance
              with this clause.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo27", tabStops: "list 72.0pt" }}
            >
              The Provider shall not access the Portal outside of the EEA and shall ensure that no
              data downloaded from the Portal is taken outside of the EEA.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo27", tabStops: "list 72.0pt" }}
            >
              Where the Introducer requests that the Provider enters into a Network Access Agreement
              the Introducer shall ensure that it has in each case obtained all necessary consents
              in writing, from Customers or otherwise, under Data Protection Laws to permit the
              Provider to enter into a Network Access Agreement and to allow the network access to
              the information on the Portal and the Introducer shall provide copies of such consents
              to the Provider on request.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={12} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>DATA SECURITY</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={12} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo30", tabStops: "list 72.0pt" }}
            >
              The Provider shall take reasonable steps to adopt, implement, maintain and follow, in
              a manner which is reflective of industry standards, practices, protective measures,
              security practices and procedures which contain administrative, technical,
              organisational and physical safeguards designed to protect the security and
              confidentiality of the Portal, including but not limited to firewalls,
              anti-virus/anti-malware, server back up, patch management, software updates and
              physical security measures.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo30", tabStops: "list 72.0pt" }}
            >
              The Introducer shall adopt, implement, maintain and follow, in a manner which is
              reflective of industry standards and practices, protective measures, security
              practices and procedures which contain administrative, technical, organisational and
              physical safeguards to protect the security, integrity and confidentiality of the
              Portal (and any information or data on or which is processed using or through the
              same), including but not limited to firewalls, anti-virus/anti-malware, server back
              up, patch management, software updates and physical security measures; and the
              Introducer shall, without prejudice to the foregoing, comply with any security and
              information security requirements in the any policies provided by the Provider from
              time to time.{" "}
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={13} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>PROVIDER WARRANTIES AND LIMITATION OF LIABILITY</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={13} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo31", tabStops: "list 72.0pt" }}
            >
              The Provider warrants that it has the right to grant the licence as set out in
              Schedule 1 to this Agreement.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo31", tabStops: "list 72.0pt" }}
            >
              Any other warranties from the Provider (if any) in respect of the provision of the
              Portal are set out in the Licence.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo31", tabStops: "list 72.0pt" }}
            >
              The Provider shall have no liability to the Introducer for any loss or damage caused
              or suffered by the Introducer, save to the extent that it is caused by a breach of the
              warranty set out in subclause 13.1 or a warranty (if any) contained in the Licence.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo31", tabStops: "list 72.0pt" }}
            >
              The Provider does not provide any warranties for the accuracy of Information on the
              Portal and the Provider shall have any liability for any loss or damage caused or
              suffered by inaccurate Information.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo31", tabStops: "list 72.0pt" }}
            >
              The Portal is provided on an “as is” basis and the Provider shall have no liability
              for any loss or damage should the Portal be inaccessible or unavailable for whatever
              reason.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo31", tabStops: "list 72.0pt" }}
            >
              The Provider shall not have any liability to the Introducer for (a) Any indirect or
              consequential loss or damage; (b) any loss of, damage to or corruption of data (unless
              the Licence provides otherwise); (c) any loss or damage to property (unless the
              Licence provides otherwise); (d) any loss or damage relating to a claim by another
              party to this Agreement; (e) any loss of profit; (f) loss of business; (g) loss of
              goodwill; (d) loss of contracts; (e) loss of revenues or loss of anticipated savings.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo31", tabStops: "list 72.0pt" }}
            >
              In the event that the Provider accepts any liability under this Agreement such
              liability will not exceed:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={13} type={1}>
          <ol style={{ marginTop: "0cm" }} start={7} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo33", tabStops: "list 108.0pt" }}
              >
                The sum of £1,000 for any individual incident;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo33", tabStops: "list 108.0pt" }}
              >
                The total of £10,000 for any number of incidents in any calendar year;
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={13} type={1}>
          <ol style={{ marginTop: "0cm" }} start={8} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo31", tabStops: "list 72.0pt" }}
            >
              Except as expressly set out in this Agreement, all warranties, undertakings,
              conditions and terms, express or implied, whether by common law, statute, custom,
              trade usage, course of dealings or otherwise (including without limitation as to
              quality, fitness for purpose, performance or suitability for purpose) in respect of
              the performance of this Agreement by the Provider and the accuracy and completeness of
              the information provided through the Portal are hereby excluded to the fullest extent
              permitted by law.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo31", tabStops: "list 72.0pt" }}
            >
              Nothing in this clause shall limit or exclude the Provider’s liability for death or
              personal injury caused by its negligence, for its fraud or the fraud of its employees,
              servants or agents, for any liability that cannot be excluded under Financial Services
              Legislation, or for any other liability that it cannot lawfully exclude.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={14} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>INDEMNITIES</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={14} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo34", tabStops: "list 72.0pt" }}
            >
              The Introducer will indemnify the Provider against any and all loss and damage
              incurred by them as a result of:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={14} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo35", tabStops: "list 108.0pt" }}
              >
                The Introducer breaching this Agreement;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo35", tabStops: "list 108.0pt" }}
              >
                The Introducer breaching the Licence;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo35", tabStops: "list 108.0pt" }}
              >
                A Customer of the Introducer using the Portal;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo35", tabStops: "list 108.0pt" }}
              >
                Any use of Information by the Introducer, or a Customer of the Introducer, or any
                other third party who has obtained the Information as a result of the actions of the
                Introducer, whether directly or indirectly;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo35", tabStops: "list 108.0pt" }}
              >
                An Introducer or Customer misusing any third party links on the Portal.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={15} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>TERMINATION</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={15} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo36", tabStops: "list 72.0pt" }}
            >
              This Agreement shall continue until terminated under this clause;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo36", tabStops: "list 72.0pt" }}
            >
              The Provider may terminate this Agreement on not less than thirty (30) days' notice in
              writing to the Introducer.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo36", tabStops: "list 72.0pt" }}
            >
              Any party may terminate this Agreement:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={15} type={1}>
          <ol style={{ marginTop: "0cm" }} start={3} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo37", tabStops: "list 108.0pt" }}
              >
                On 14 days written notice to the other parties should another party be in material
                breach of this Agreement and that other party fails, in respect of a breach capable
                of being remedied, within 14 days after the receipt of a request in writing from the
                notifying party to do so, to remedy the breach;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo37", tabStops: "list 108.0pt" }}
              >
                Immediately on giving written notice should an interim order be made, or a voluntary
                arrangement approved, or if a petition for bankruptcy order is presented or a
                bankruptcy order is made against another party or if a receiver or trustee is
                appointed of another party's estate or a voluntary arrangement is approved or an
                administration order is made, or a receiver or administrative receiver is appointed
                over any of another party's assets or undertaking or a resolution or petition to
                wind up another party is passed or presented (otherwise than for the purposes of
                reconstruction or amalgamation), or if any circumstances arise which entitle the
                Court or a creditor to appoint a receiver, administrative receiver or administrator
                or to present a winding up petition or make a winding up order.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={15} type={1}>
          <ol style={{ marginTop: "0cm" }} start={4} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo36", tabStops: "list 72.0pt" }}
            >
              The Provider may immediately terminate this Agreement by giving written notice to the
              other parties immediately should:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={15} type={1}>
          <ol style={{ marginTop: "0cm" }} start={4} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo38", tabStops: "list 108.0pt" }}
              >
                the Introducer inform the Provider of any material fact pursuant to subclause 7.4
                above;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo38", tabStops: "list 108.0pt" }}
              >
                the Provider <span style={{ msoSpacerun: "yes" }}>&nbsp;</span>shall reasonably
                suspect that the Introducer is in breach of clauses 2, 4 or 7; or
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo38", tabStops: "list 108.0pt" }}
              >
                the Provider shall be of the reasonable opinion that the Introducer has in any way
                damaged or may damage the reputation or business of the Provider;
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={15} type={1}>
          <ol style={{ marginTop: "0cm" }} start={5} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo36", tabStops: "list 72.0pt" }}
            >
              Upon termination:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={15} type={1}>
          <ol style={{ marginTop: "0cm" }} start={5} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo39", tabStops: "list 108.0pt" }}
              >
                Each party shall pay to any other party any sums due up to the date of termination;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo39", tabStops: "list 108.0pt" }}
              >
                In accordance with the terms of the Licence the Introducer's right to use the Portal
                will end;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo39", tabStops: "list 108.0pt" }}
              >
                The Introducer shall, at the Provider's discretion, either return or destroy all
                material that contains Confidential Information of the Provider (save for any
                material that has come into the public domain other than by a breach of a duty of
                confidentiality by the Introducer), or any material that contains the Provider's
                Intellectual Property Rights;
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={15} type={1}>
          <ol style={{ marginTop: "0cm" }} start={6} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo36", tabStops: "list 72.0pt" }}
            >
              The obligations of the parties under clauses 4.3, 8, 9, 10, 13.3, 13.5 to 13.12, 14,
              15.5, 15.6, 17, 19, 23, 24, 25, 26, 28, 31, 33 shall survive the termination of this
              Agreement.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={16} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>NOTICES</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l7 level2 lfo109", tabStops: "list 72.0pt" }}
            >
              Unless a clause of this Agreement provides otherwise all notices under this Agreement
              shall be in writing and must be in English;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l7 level2 lfo109", tabStops: "list 72.0pt" }}
            >
              Unless a clause of this Agreement provides otherwise notices shall be deemed to have
              been duly given:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <ol style={{ marginTop: "0cm" }} start={2} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l7 level3 lfo110", tabStops: "list 108.0pt" }}
              >
                When delivered, if delivered by courier or other messenger (including registered
                mail) during normal business hours of the recipient; or
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l7 level3 lfo110", tabStops: "list 108.0pt" }}
              >
                When sent, if transmitted by email and a successful transmission report or return
                receipt is generated; or
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l7 level3 lfo110", tabStops: "list 108.0pt" }}
              >
                On the fifth business day of the sender following mailing, if mailed by national
                ordinary mail, postage prepaid; or
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l7 level3 lfo110", tabStops: "list 108.0pt" }}
              >
                On the tenth business day of the sender following mailing, if mailed by airmail,
                postage prepaid;
              </li>
            </ol>
          </ol>
        </ol>
        <p className="MsoNormal">
          in each case addressed to the most recent address, email address, or facsimile number
          notified to the other party.
        </p>
        <ol style={{ marginTop: "0cm" }} start={17} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>NON-POACHING OF STAFF OR CONTACTING SUPPLIERS</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={17} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo42", tabStops: "list 72.0pt" }}
            >
              The Introducer covenants with the Provider that it shall not either during the term of
              this Agreement or within a period of 6 months thereafter:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={17} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo43", tabStops: "list 108.0pt" }}
              >
                directly or indirectly entice away or endeavour to entice away from the Provider any
                person who has during the previous 12 months been employed by the Provider to
                perform this Agreement;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo43", tabStops: "list 108.0pt" }}
              >
                attempt to purchase any data from any supplier of data to the Provider, where that
                company has supplied data to the Provider within the pervious 12 months and where
                the Introducer has either become aware of the supplier through the use of this
                Portal or through this Agreement.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={18} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>NATURE OF RELATIONSHIP</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={18} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo44", tabStops: "list 72.0pt" }}
            >
              This Agreement shall not constitute or imply any partnership, joint venture, agency,
              fiduciary or other relationship between the parties other than the contractual
              relationship expressly provided for in this Agreement;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo44", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not use the Portal in a manner that implies or otherwise
              misrepresents that any act of the Introducer is approved or endorsed by the Provider.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={19} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>ANNOUNCEMENTS</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={19} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo45", tabStops: "list 72.0pt" }}
            >
              No party shall issue or make any public announcement or disclose any information
              regarding this Agreement unless prior written consent has been obtained from the other
              parties.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={20} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>AMENDMENTS</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={20} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo46", tabStops: "list 72.0pt" }}
            >
              This Agreement may not be released, discharged, supplemented, interpreted, amended,
              varied or modified in any manner except by:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={20} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo47", tabStops: "list 108.0pt" }}
              >
                an instrument in writing signed by a duly authorised officer or representative of
                each party; or
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo47", tabStops: "list 108.0pt" }}
              >
                the Provider, by publishing such amendments on the Portal, provided that the
                Provider shall draw the fact that the Agreement has been amended to the attention of
                the Introducer when the Introducer next accesses the Portal, and shall invite the
                Introducer to consent to such amendments by a suitable method, for example the
                completion of an online tick box. The amendments shall take affect from the
                Introducer giving such consent, and all parties hereby expressly agree that any
                amendments consented to in such a manner shall be binding on them. Should the
                Introducer not agree to such amendments the Provider shall not be required to allow
                the Introducer further access to the Portal.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={21} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>ENTIRE AGREEMENT</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={21} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo48", tabStops: "list 72.0pt" }}
            >
              This Agreement supersedes all prior agreements, arrangements and undertakings between
              the Introducer and the Provider and constitutes the entire agreement between the them
              relating to its subject matter. The parties confirm that they have not entered into
              this Agreement on the basis of any representation that is not expressly incorporated
              into this Agreement.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={22} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>ASSIGNMENT</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={22} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo49", tabStops: "list 72.0pt" }}
            >
              This Agreement is personal to the Introducer and the Introducer may not assign or
              transfer this Agreement nor any rights, licences or obligations under it without the
              prior written approval of the other parties;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo49", tabStops: "list 72.0pt" }}
            >
              The Provider may assign their rights and licences and transfer their obligations under
              this Agreement without the consent of the Introducer.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={23} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>SUCCESSORS AND ASSIGNEES</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={23} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo50", tabStops: "list 72.0pt" }}
            >
              This Agreement shall be binding upon, and inure to the benefit of, the parties and
              their respective successors and permitted assignees, and references to a party in this
              Agreement shall include its successors and permitted assignees;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo50", tabStops: "list 72.0pt" }}
            >
              In this Agreement references to a party include references to a person:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={23} type={1}>
          <ol style={{ marginTop: "0cm" }} start={2} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo51", tabStops: "list 108.0pt" }}
              >
                Who for the time being is entitled (by assignment, novation or otherwise) to that
                party's rights under this Agreement (or any interest in those rights); or
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo51", tabStops: "list 108.0pt" }}
              >
                Who, as administrator, liquidator or otherwise, is entitled to exercise those
                rights;
              </li>
            </ol>
          </ol>
        </ol>
        <p className="MsoNormal">
          and in particular those references include a person to whom those rights (or any interest
          in those rights) are transferred or pass as a result of a merger, division, reconstruction
          or other reorganisation involving that party. For this purpose, references to a party's
          rights under this Agreement include any similar rights to which another person becomes
          entitled as a result of a novation of this Agreement.
        </p>
        <ol style={{ marginTop: "0cm" }} start={24} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>WAIVER</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={24} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo52", tabStops: "list 72.0pt" }}
            >
              Unless the Provider expressly waives its rights in writing, no delay, neglect or
              forbearance by the Provider in enforcing against the Introducer any term or condition
              of this Agreement shall either be or be deemed to be a waiver or in any way prejudice
              any right of the Provider under this Agreement. No right, power or remedy in this
              Agreement conferred upon or reserved for the Provider is exclusive of any other right,
              power or remedy available to that party.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={25} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>SEVERANCE</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={25} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo53", tabStops: "list 72.0pt" }}
            >
              If any provision of this Agreement is or becomes prohibited by law or is judged by a
              court to be unlawful, void or unenforceable, the provision shall, to the extent
              required, be severed from this Agreement and rendered ineffective as far as possible
              without modifying the remaining provisions of this Agreement, and shall not in any way
              affect any other circumstances of or the validity or enforcement of the remainder of
              this Agreement.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={26} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>FORCE MAJEURE</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={26} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo54", tabStops: "list 72.0pt" }}
            >
              No party shall have any liability under or be deemed to be in breach of this Agreement
              for any delays or failures in performance of this Agreement which result from
              circumstances beyond the reasonable control of that party. If such circumstances
              continue for a continuous period of more than 3 months, any non-affected party may
              terminate this Agreement by written notice to the other parties.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={27} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>TIME OF THE ESSENCE</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={27} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo55", tabStops: "list 72.0pt" }}
            >
              Time shall be of the essence in this Agreement as regards any time, date or period
              mentioned in this Agreement or subsequently substituted as a time, date or period by
              agreement in writing between the parties.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={28} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>SET-OFF</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={28} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo56", tabStops: "list 72.0pt" }}
            >
              The Introducer may not set off any sums that are owed to it by either the Provider,
              whether under this Agreement or otherwise, against any liability that the Introducer
              has to such a party;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo56", tabStops: "list 72.0pt" }}
            >
              Where either the Provider has a liability to the Introducer, whether under this
              Agreement or otherwise, and whether such liability is liquidated or unliquidated, that
              party may set off the amount of such liability against any sum that would otherwise be
              due from the Introducer under this Agreement.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={29} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>LANGUAGE</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={29} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo57", tabStops: "list 72.0pt" }}
            >
              This Agreement is made only in the English language. If there is any conflict in the
              meaning between the English language version of this Agreement and any version or
              translation of it in any other language, the English language version shall prevail.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={30} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>COSTS AND EXPENSES</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={30} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo58", tabStops: "list 72.0pt" }}
            >
              Each party shall bear its own legal costs and other costs and expenses arising in
              connection with the drafting, negotiation, execution and registration (if applicable)
              of this Agreement.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={31} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>THIRD PARTIES</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={31} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo59", tabStops: "list 72.0pt" }}
            >
              Without prejudice to any right or remedy of a third party which exists or is available
              apart from such Act, a person who is not a party to this Agreement has no right under
              the Contracts (Rights of Third Parties) Act 1999 to enforce any term of this
              Agreement. The parties to this Agreement do not require the consent of any third party
              to terminate, rescind or to agree any variation, waiver or settlement in relation to
              it.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={32} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>SUBCONTRACTING</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={32} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo59", tabStops: "list 72.0pt" }}
            >
              Notwithstanding anything in this Agreement, it is acknowledged and agreed that the
              Provider may subcontract or delegate its obligations under this Agreement from time to
              time and the Provider shall be responsible for the acts and omissions of its
              subcontractors as if such acts and omissions were its own under this Agreement.{" "}
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={33} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>PROPER LAW AND JURISDICTION</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={33} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo60", tabStops: "list 72.0pt" }}
            >
              The parties agree that the place of performance of this Agreement is England. This
              Agreement and all matters arising from it and any dispute resolutions referred to
              below shall be governed by and construed in accordance with English law
              notwithstanding the conflict of law provisions and other mandatory legal provisions
              save that:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={33} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo61", tabStops: "list 108.0pt" }}
              >
                The Provider shall have the right to sue to recover its loss or damage in any
                jurisdiction in which the Introducer is operating or has assets; and
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l12 level3 lfo61", tabStops: "list 108.0pt" }}
              >
                The Provider shall have the right to sue for breach of its Intellectual Property
                Rights and other proprietary information (whether in connection with this Agreement
                or otherwise) in any country where it believes that infringement or a breach of this
                Agreement relating to its Intellectual Property Rights and/or other proprietary
                information might be taking place;
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={33} type={1}>
          <ol style={{ marginTop: "0cm" }} start={2} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo60", tabStops: "list 72.0pt" }}
            >
              Each party recognises that the other party's business relies upon the protection of
              its Intellectual Property Rights and that in the event of a breach or threatened
              breach of its Intellectual Property Rights, the other party will be caused irreparable
              damage and such other party may therefore be entitled to injunctive or other equitable
              relief in order to prevent a breach or threatened breach of its Intellectual Property
              Rights;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo60", tabStops: "list 72.0pt" }}
            >
              With respect to all other disputes which are not disputes about Intellectual Property
              Rights the following procedures in subclauses 33.4 to 33.5 shall apply;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo60", tabStops: "list 72.0pt" }}
            >
              Where there is a dispute the aggrieved party shall notify the other parties in writing
              of the nature of the dispute with as much detail as possible about the deficient
              performance of the other party or parties. A representative from senior management of
              each party ('representatives') shall meet in person or communicate by telephone within
              5 business days of the date of the written notification in order to reach an agreement
              about the nature of the deficiency and the corrective action to be taken by each
              party. The representatives shall produce a report about the nature of the dispute in
              detail to their respective boards and if no agreement is reached on corrective action,
              then the chief executives of each party shall meet in person or communicate by
              telephone, to facilitate an agreement within 5 business days of a written notice by
              one to the other. If the dispute cannot be resolved at board level within a further 5
              business days, or if the agreed upon completion dates in any written plan of
              corrective action are exceeded, any party may seek its legal remedies as provided
              below. Where the Introducer is not a body corporate references in this clause to
              “board” and “chief executive” shall be to their nearest equivalent;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo60", tabStops: "list 72.0pt" }}
            >
              If the parties cannot resolve a dispute in accordance with the procedure in subclause
              33.4 above, then the dispute shall be promptly referred to an independent party to act
              as arbitrator. The arbitrator shall be jointly appointed by the parties or, in the
              default of agreement within 14 days of one party first notifying the other parties of
              a proposed arbitrator, by the President of the Institute of Chartered Accountants in
              England and Wales on application of any party, who shall finally appoint an
              independent accountant to resolve the dispute. Save in the event of manifest error,
              the independent arbitrator's decision shall be final and binding upon the parties;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo60", tabStops: "list 72.0pt" }}
            >
              While the dispute resolution procedure above is in progress and any party has an
              obligation to make a payment to the other party or to allow a credit in respect of
              such payment, the sum relating to the matter in dispute shall be paid into an interest
              bearing deposit account to be held in the name of the relevant party at a clearing
              bank and such payment shall be a good discharge of that party's payment obligations
              under this Agreement. Following resolution of the dispute the sum held in such account
              shall be payable as determined in accordance with the resolution, and the interest
              accrued shall be allocated between the parties pro rata according to the split of the
              principal sum as between the parties.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={34} type={1}>
          <li className="MsoNormal" style={{ msoList: "l12 level1 lfo3", tabStops: "list 36.0pt" }}>
            <b>SIGNING</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={34} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo62", tabStops: "list 72.0pt" }}
            >
              The Provider shall provide the Agreement to the Introducer for electronic execution.
              Such provision may but shall not have to be via the Portal. Such provision shall
              constitute an offer by the Provider to enter into this Agreement with the Introducer;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo62", tabStops: "list 72.0pt" }}
            >
              The Introducer shall execute the Agreement electronically by following such
              instructions as are given to it by the Provider in order to so execute the Agreement
              electronically;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l12 level2 lfo62", tabStops: "list 72.0pt" }}
            >
              This Agreement shall be binding upon all parties upon being electronically executed by
              the Introducer.
            </li>
          </ol>
        </ol>
        <b>
          <span
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Aptos",sans-serif',
              msoAsciiThemeFont: "minor-latin",
              msoFareastFontFamily: "Aptos",
              msoFareastThemeFont: "minor-latin",
              msoHansiThemeFont: "minor-latin",
              msoBidiFontFamily: '"Times New Roman"',
              msoBidiThemeFont: "minor-bidi",
              msoAnsiLanguage: "EN-GB",
              msoFareastLanguage: "EN-US",
              msoBidiLanguage: "AR-SA"
            }}
          >
            <br
              clear="all"
              style={{ msoSpecialCharacter: "line-break", pageBreakBefore: "always" }}
            />
          </span>
        </b>
        <p className="MsoNormal">
          <b>&nbsp;</b>
        </p>
        <p className="MsoNormal">
          <b>SCHEDULE 1 - PORTAL LICENCE</b>
        </p>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <li
            className="MsoNormal"
            style={{ msoList: "l11 level1 lfo67", tabStops: "list 36.0pt" }}
          >
            <b>Definitions</b>
          </li>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo67", tabStops: "list 72.0pt" }}
            >
              In this Licence, any words defined in the Agreement shall have the same meaning.
            </li>
          </ol>
          <li
            className="MsoNormal"
            style={{ msoList: "l11 level1 lfo67", tabStops: "list 36.0pt" }}
          >
            <b>Licence</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={2} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo68", tabStops: "list 72.0pt" }}
            >
              The use of the Portal is subject to this Licence;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo68", tabStops: "list 72.0pt" }}
            >
              The Licence shall commence on the date of the Agreement and continue until the
              Agreement is terminated, unless otherwise suspended or terminated under the terms of
              the Agreement.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={3} type={1}>
          <li
            className="MsoNormal"
            style={{ msoList: "l11 level1 lfo67", tabStops: "list 36.0pt" }}
          >
            <b>Access</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={3} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo69", tabStops: "list 72.0pt" }}
            >
              The Introducer shall access the Portal by visiting the web address as communicated to
              the Introducer by the Provider and registering on the Portal as further provided for
              below;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo69", tabStops: "list 72.0pt" }}
            >
              The Introducer shall follow any reasonable instructions that the Provider may give to
              the Introducer for access to the Portal;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo69", tabStops: "list 72.0pt" }}
            >
              It is the Introducer's responsibility, at its own cost, to ensure that it has suitable
              equipment and facilities that can access the Portal (such as an internet connection)
              and that such equipment and facilities are compatible with the Portal. The Provider
              shall have no responsibility for the Introducer's inability to access the Portal as a
              result of such equipment and facilities not being suitable;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo69", tabStops: "list 72.0pt" }}
            >
              The Provider will use reasonable efforts to ensure that the Portal is available at all
              times. However the Provider cannot guarantee that the Portal or any individual
              function or feature of the Portal will always be available and/or error free. In
              particular, and without limitation to the above, the Provider may restrict the
              Introducer's access to the Portal, or to part of it, and whether temporarily or
              permanently, in the following circumstances:
            </li>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l11 level3 lfo69", tabStops: "list 108.0pt" }}
              >
                The Provider has reason to suspect that the Introducer's username and/or password
                are being used by a person who is not authorised to use it/them;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l11 level3 lfo69", tabStops: "list 108.0pt" }}
              >
                To carry out maintenance or upgrade work to the Portal;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l11 level3 lfo69", tabStops: "list 108.0pt" }}
              >
                The Provider has reason to suspect that the Introducer is acting in breach of the
                Agreement or this Licence;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l11 level3 lfo69", tabStops: "list 108.0pt" }}
              >
                The Provider has reason to suspect that the Portal is being used fraudulently or for
                any unlawful purpose;
              </li>
            </ol>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo69", tabStops: "list 72.0pt" }}
            >
              The Introducer's right to access the Portal is personal to it and may not be
              transferred.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo69", tabStops: "list 72.0pt" }}
            >
              The Provider may, but is under no obligation to, make available technical support for
              the Portal. Where such technical support is available then in the event of the
              Introducer being unable to access or utilise, whether fully or in part, the Portal or
              in the event of a technical problem with the Portal the Introducer shall, in the first
              instance, contact such technical support. The Introducer shall fully co-operate with
              the technical support, including following any reasonable instructions from such
              technical support;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo69", tabStops: "list 72.0pt" }}
            >
              The Provider does not warrant that any technical support provided under paragraph 3.6
              above shall remedy or assist with any technical issue.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo69", tabStops: "list 72.0pt" }}
            >
              The technical support provided under paragraph 3.6 above it provided on a best
              endeavours basis and the Provider does not provide any warranty that the technical
              support shall be provided with reasonable care and skill, and does not accept any
              liability for any loss or damage caused by the technical support, subject to paragraph
              3.9 below.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo69", tabStops: "list 72.0pt" }}
            >
              Where any technical support is provided negligently and that technical support results
              in either damage to the Introducer's computer equipment or loss of the Introducer's
              data the Provider shall accept liability for such loss subject to the limits set out
              in the Agreement.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={4} type={1}>
          <li
            className="MsoNormal"
            style={{ msoList: "l11 level1 lfo67", tabStops: "list 36.0pt" }}
          >
            <b>Users</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={4} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo70", tabStops: "list 72.0pt" }}
            >
              The Introducer shall register on the Portal and create a username and password for
              each user that shall access the Portal;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo70", tabStops: "list 72.0pt" }}
            >
              The password created pursuant to paragraph 4.1 above shall comply with any
              requirements that the Provider shall stipulate as content, and the Introducer shall
              ensure that each user shall regularly change the password;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo70", tabStops: "list 72.0pt" }}
            >
              The Introducer shall ensure that only authorised users are given a username and
              password and that such users do not divulge the username and password to any other
              person;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo70", tabStops: "list 72.0pt" }}
            >
              Any acts by any person with a correct username and password shall be deemed to be done
              with the authority of the Introducer;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo70", tabStops: "list 72.0pt" }}
            >
              The Introducer shall notify the Provider immediately if the Introducer becomes aware
              of any unauthorised use of a username and password or other unauthorised access to the
              Portal.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={5} type={1}>
          <li
            className="MsoNormal"
            style={{ msoList: "l11 level1 lfo67", tabStops: "list 36.0pt" }}
          >
            <b>Use</b>
          </li>
        </ol>
        <p className="MsoNormal">
          <b>Introducer responsibilities </b>
        </p>
        <ol style={{ marginTop: "0cm" }} start={5} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall only use the Portal in a manner that is compliant with the
              Agreement and this Licence and for the purposes of conducting business in accordance
              with the Agreement;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not do any act or allow any act to occur, including by its use of
              the Portal, that will or may have the result of disrupting access to or the
              availability of the Portal to Users or to Insurers that use the Portal;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall use the Portal in a professional manner and shall not{" "}
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                access, store, distribute or transmit: (a) any viruses; or (b) any material that:
                (i) is unlawful, harmful, threatening, defamatory, obscene, infringing, harassing or
                racially or ethnically offensive; (ii) facilitates illegal activity; (iii) depicts
                sexually explicit images; (iv) promotes unlawful violence; (v) is discriminatory
                based on race, gender, colour, religious belief, sexual orientation, disability; or
                (vi) is otherwise illegal or causes damage or injury to any person or property, and,
                in each case, the Provider reserves the right, without liability or prejudice to its
                other rights to the Introducer, to disable the Introducer's access to any material
                that breaches any of the provisions of this clause;
              </span>
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall at all times use and maintain commercial virus software on any
              equipment which it uses to access the Portal, such virus software to be kept up to
              date and to be at least of a standard that would be expected to be maintained by a
              commercial entity using the internet to conduct its business affairs;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not reproduce, duplicate, copy, sell, resell, or otherwise
              exploit for any commercial purposes, any portion of, use of, or access to the Portal;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not transmit or otherwise make available in connection with the
              Portal any virus, worm, Trojan horse or other computer code that is harmful or
              invasive or may or is intended to damage the operation of, or to monitor the use of,
              any hardware, software, or equipment;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not translate, adapt, vary, modify, disassemble, decompile or
              reverse engineer the Portal without the Provider's prior written consent;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not remove any copyright, trade mark or other proprietary rights
              notice from the Portal or materials originating from the Portal;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not create a database by systematically downloading and storing
              Portal content;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not frame or mirror any part of the Portal without the Provider's
              express prior written consent;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not use any manual or automatic device in any way to gather
              Portal content or reproduce or circumvent the navigational structure or presentation
              of the Portal without the Provider's express prior written consent;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not amend or modify any documents provided by the Portal and
              shall not manipulate any information contained in such documents;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not duplicate any material obtained through the Portal without
              the prior written consent of the Provider, other than in connection with the ordinary
              transaction of business through the Portal as envisaged by the Agreement.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              The Introducer shall not{" "}
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                build or enhance a competitive product or service; (ii) to build or enhance a
                product or service using similar ideas, features, functions or graphics of (in whole
                or in part) the Portal (iii) to copy any ideas, features, functions or graphics of
                (in whole or in part) the Portal, or (iv) in any manner that is or may be
                competitive to the Provider or any member of its group, attempt to obtain, or assist
                third parties in obtaining, unauthorised access to or interfere with the proper
                working of (in whole or in part) the Portal, including any attempt to circumvent
                security, licence control or other protection mechanisms;
              </span>
            </li>
          </ol>
        </ol>
        <p className="MsoNormal">
          <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
            As between the parties, the Provider shall not be responsible for each of the following:{" "}
          </span>
        </p>
        <ol style={{ marginTop: "0cm" }} start={5} type={1}>
          <ol style={{ marginTop: "0cm" }} start={15} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                for the security, availability, integrity, support and maintenance (including any
                defects, delays or failures) of the Introducer’s systems, or for any incompatibility
                between the Introducer’s systems and the Portal;{" "}
              </span>
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                ensuring continued connectivity of, and availability of, the Introducer systems to
                the Portal;
              </span>
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              <span style={{ msoBookmark: "a1044295" }}>
                <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                  for procuring, maintaining and securing the Introducer's network connections and
                  telecommunications links from the Introducer systems to the Portal, and for all
                  problems, conditions, delays, delivery failures and all other loss or damage
                  arising from or relating to telecommunications networks or the internet or the
                  transfer of data over communications networks and facilities (including the
                  Introducer's network connections or telecommunications links) or caused by the
                  internet
                </span>
              </span>
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                {" "}
                and the Introducer acknowledges that the Portal may be subject to limitations,
                delays and other problems inherent in the use of such communications facilities; and{" "}
              </span>
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo71", tabStops: "list 72.0pt" }}
            >
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                ensuring the Introducer’s systems remain operable during business hours, it being
                acknowledged that the Portal will not be able to offer the services if the
                Introducer’s systems are not operable.
              </span>
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={6} type={1}>
          <li
            className="MsoNormal"
            style={{ msoList: "l11 level1 lfo67", tabStops: "list 36.0pt" }}
          >
            <b>Customer Use</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={6} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo72", tabStops: "list 72.0pt" }}
            >
              The Introducer may allow Customers to view the Portal for the purpose of reviewing
              Customer Information submitted to the Portal on their behalf and for the purpose of
              explaining to the Customer the actions that the Introducer and the Provider is
              carrying out on the Customer's behalf;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo72", tabStops: "list 72.0pt" }}
            >
              The Customer shall not be entitled to access or use the Portal.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={7} type={1}>
          <li
            className="MsoNormal"
            style={{ msoList: "l11 level1 lfo67", tabStops: "list 36.0pt" }}
          >
            <b>External Content</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={7} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo73", tabStops: "list 72.0pt" }}
            >
              The Portal may provide links to other websites. The Provider is not responsible for
              and does not endorse such external websites. The Introducer's use of third party
              websites it at its own risk.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={8} type={1}>
          <li
            className="MsoNormal"
            style={{ msoList: "l11 level1 lfo67", tabStops: "list 36.0pt" }}
          >
            <b>Property and Intellectual Property Rights</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={8} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo74", tabStops: "list 72.0pt" }}
            >
              <span style={{ msoBidiFontSize: "10.0pt", lineHeight: "115%" }}>
                Notwithstanding anything in these terms and conditions, as between the parties, all
                Intellectual Property Rights in and to the Portal and any amendments or
                modifications to any of the foregoing, (the{" "}
                <b style={{ msoBidiFontWeight: "normal" }}>Provider IPR</b>), shall vest in and
                remain vested in the Provider. All uses of the Provider IPR, including all goodwill
                arising from such use, shall accrue solely to the benefit of the Provider. The
                Introducer hereby irrevocably transfers and assigns to the Provider, and agrees to
                transfer and assign to the Provider, any and all Intellectual Property Rights in the
                Portal (or any materials comprising the Provider IPR) which has vested in it, its
                group companies, suppliers or subcontractors, in each case, with full title
                guarantee. The Introducer shall, at the request of the Provider, and at its own cost
                and expense, take all steps and sign all deeds and documents to give effect to this
                clause.
              </span>
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo74", tabStops: "list 72.0pt" }}
            >
              <span style={{ msoBookmark: "_Ref110572509" }}>
                <span style={{ msoBookmark: "_Ref151740382" }}>
                  <span style={{ msoBidiFontSize: "10.0pt", lineHeight: "115%" }}>
                    As between the parties, all Intellectual Property Rights in and to the{" "}
                  </span>
                  Introducer Information
                </span>
              </span>
              <span style={{ msoBookmark: "_Ref110572509" }}>
                <span style={{ msoBookmark: "_Ref151740382" }}>
                  <span style={{ msoBidiFontSize: "10.0pt", lineHeight: "115%" }}>
                    , (the <b>Introducer IPR</b>) shall vest in and remain vested in the Introducer.{" "}
                  </span>
                </span>
              </span>
              <span style={{ msoBookmark: "_Ref146900142" }}>
                <span style={{ msoBookmark: "_Ref110582954" }}>
                  <span style={{ msoBookmark: "_Ref151740382" }}>
                    <span style={{ msoBidiFontSize: "10.0pt", lineHeight: "115%" }}>
                      The Introducer grants to the Provider for the term a royalty-free,
                      non-exclusive, sub-licensable, non-transferable (other than to any person who
                      has been assigned Provider's rights under these terms and conditions in
                      accordance with this Agreement) licence to access, modify, store and use the
                      Introducer IPR (including all materials and software materials comprising the
                      Introducer IPR) and any other materials which are provided or made available
                      by or on behalf of the Introducer to the Provider, its employees, group
                      companies or subcontractors for the purposes of the operation, improvement,
                      development, maintenance and the provision of the Portal
                    </span>
                  </span>
                </span>
              </span>
              <span style={{ msoBidiFontSize: "10.0pt", lineHeight: "115%" }}>. </span>
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo74", tabStops: "list 72.0pt" }}
            >
              The Introducer may only use and reproduce material (including all documents,
              databases, information, names and logos) accessed through the Portal in accordance
              with the Agreement and this Licence.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={9} type={1}>
          <li
            className="MsoNormal"
            style={{ msoList: "l11 level1 lfo67", tabStops: "list 36.0pt" }}
          >
            <b>Amendment</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={9} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo75", tabStops: "list 72.0pt" }}
            >
              The Provider may from time to time amend the terms of this Licence. The Provider may
              notify the Introducer of such amendments by any reasonable means, including by posting
              the revised version of this Licence on the Portal. The Introducer's use of the Portal
              following changes to this Licence will constitute its acceptance of the changes.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <li
            className="MsoNormal"
            style={{ msoList: "l11 level1 lfo67", tabStops: "list 36.0pt" }}
          >
            <b>Warranties and Limitation of Liability</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo76", tabStops: "list 72.0pt" }}
            >
              The internet is inherently unreliable and the Provider shall have no liability to the
              Introducer for any loss or damage caused by hardware or software failures outside of
              its control;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo76", tabStops: "list 72.0pt" }}
            >
              The Portal is provided 'as is' and the Provider makes no representation as to the
              quality, completeness or accuracy of any content on the Portal. To the maximum extent
              permitted by law, but subject to subclause 3.9 and 10.4, the Provider expressly
              excludes:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <ol style={{ marginTop: "0cm" }} start={2} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l11 level3 lfo77", tabStops: "list 108.0pt" }}
              >
                All conditions, warranties and other terms that might otherwise be implied by law
                into this Licence; and
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l11 level3 lfo77", tabStops: "list 108.0pt" }}
              >
                Any and all liability to the Introducer, whether arising under this Licence or
                otherwise, in connection with the Introducer's access to and use of the Portal;
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <ol style={{ marginTop: "0cm" }} start={3} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo76", tabStops: "list 72.0pt" }}
            >
              The limitation of liability in this clause applies to all damage of any kind,
              including without limitation compensatory, direct, indirect or consequential damages,
              loss of data, income or profit, loss or damage to property and claims of the parties;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo76", tabStops: "list 72.0pt" }}
            >
              Notwithstanding anything in this clause to the contrary, nothing in this Licence shall
              limit the Provider's liability to the Introducer for its fraud or the fraud of its
              employees, servants or agents, or for death or personal injury caused by its
              negligence, or for any liability that may not by law be excluded or limited;
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l11 level2 lfo76", tabStops: "list 72.0pt" }}
            >
              This paragraph 10 shall survive termination of the Licence.
            </li>
          </ol>
        </ol>
        <b>
          <span
            style={{
              fontSize: "12.0pt",
              lineHeight: "115%",
              fontFamily: '"Aptos",sans-serif',
              msoAsciiThemeFont: "minor-latin",
              msoFareastFontFamily: "Aptos",
              msoFareastThemeFont: "minor-latin",
              msoHansiThemeFont: "minor-latin",
              msoBidiFontFamily: '"Times New Roman"',
              msoBidiThemeFont: "minor-bidi",
              msoAnsiLanguage: "EN-GB",
              msoFareastLanguage: "EN-US",
              msoBidiLanguage: "AR-SA"
            }}
          >
            <br
              clear="all"
              style={{ msoSpecialCharacter: "line-break", pageBreakBefore: "always" }}
            />
          </span>
        </b>
        <p className="MsoNormal">
          <b>&nbsp;</b>
        </p>
        <p className="MsoNormal">
          <b>
            <span style={{ msoSpacerun: "yes" }}>&nbsp;</span>SCHEDULE 2 - DATA PROCESSING
          </b>
        </p>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Interpretation</b>
          </li>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo86", tabStops: "list 72.0pt" }}
            >
              In this Schedule the following words have the following meanings:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <ul style={{ marginTop: "0cm" }} type="disc">
              <li className="MsoNormal" style={{ msoList: "l8 level3 lfo104" }}>
                <b>
                  <span
                    style={{
                      msoBidiFontSize: "9.0pt",
                      lineHeight: "115%",
                      msoBidiFontFamily: "Arial"
                    }}
                  >
                    Data Protection Laws{" "}
                  </span>
                </b>
                <span
                  style={{
                    msoBidiFontSize: "9.0pt",
                    lineHeight: "115%",
                    msoBidiFontFamily: "Arial"
                  }}
                >
                  mean, to the extent applicable, (a){" "}
                </span>
                <span
                  style={{
                    msoBidiFontSize: "9.0pt",
                    lineHeight: "115%",
                    msoBidiFontFamily: "Arial",
                    msoBidiLanguage: "KOK"
                  }}
                >
                  (i) the UK GDPR; and (ii) the UK Data Protection Act 2018; and (iii) the Privacy
                  and Electronic Communications (EC Directive) Regulations 2003; and (b) any
                  equivalent laws relating to data protection or privacy in the Channel Islands,
                </span>
                <span
                  style={{
                    msoBidiFontSize: "9.0pt",
                    lineHeight: "115%",
                    msoFareastFontFamily: "Arial",
                    msoBidiFontFamily: "Arial",
                    msoFareastLanguage: "EN-GB",
                    msoBidiLanguage: "KOK"
                  }}
                >
                  {" "}
                  and the terms <b>controller</b>, <b>data subject</b>, <b>personal data</b>,{" "}
                  <b>personal data breach</b>, <b>processor</b>
                  and <b>processing </b>(and its variants) shall have the meaning given in the Data
                  Protection Laws
                </span>
                <span
                  style={{
                    msoBidiFontSize: "9.0pt",
                    lineHeight: "115%",
                    msoBidiFontFamily: "Arial",
                    msoBidiLanguage: "KOK"
                  }}
                >
                  .{" "}
                </span>
                <span
                  style={{
                    msoBidiFontSize: "9.0pt",
                    lineHeight: "115%",
                    msoBidiFontFamily: "Arial"
                  }}
                />
              </li>
              <li className="MsoNormal" style={{ msoList: "l8 level3 lfo104" }}>
                <b>Introducer Data</b>
                means data, including personal data, that relates to the Introducer, including
                details of customers of the Introducer or employees of the Introducer, and in
                respect of which the Introducer is the controller for the purposes of UK GDPR. It
                does not include data for which the Provider is itself the controller.
              </li>
              <li className="MsoNormal" style={{ msoList: "l8 level3 lfo104" }}>
                <b>
                  <span
                    style={{
                      msoBidiFontSize: "9.0pt",
                      lineHeight: "115%",
                      msoFareastFontFamily: "Arial",
                      msoBidiFontFamily: "Arial",
                      msoFareastLanguage: "EN-GB",
                      msoBidiLanguage: "KOK"
                    }}
                  >
                    UK GDPR{" "}
                  </span>
                </b>
                <span
                  style={{
                    msoBidiFontSize: "9.0pt",
                    lineHeight: "115%",
                    msoFareastFontFamily: "Arial",
                    msoBidiFontFamily: "Arial",
                    msoFareastLanguage: "EN-GB",
                    msoBidiLanguage: "KOK"
                  }}
                >
                  means the EU GDPR as it forms part of retained EU law in the United Kingdom
                  pursuant to the European Union (Withdrawal) Act 2018.
                </span>
              </li>
              <li className="MsoNormal" style={{ msoList: "l8 level3 lfo104" }}>
                <b>EU GDPR</b> means the General Data Protection Regulation ((EU) 2016/679).
              </li>
              <li className="MsoNormal" style={{ msoList: "l8 level3 lfo104" }}>
                <b>Supervisory Authority</b>{" "}
                <span
                  style={{
                    msoBidiFontSize: "9.0pt",
                    lineHeight: "115%",
                    msoFareastFontFamily: "Arial",
                    msoBidiFontFamily: "Arial",
                    msoFareastLanguage: "EN-GB",
                    msoBidiLanguage: "KOK"
                  }}
                >
                  means any regulatory authority responsible for the enforcement, regulation or
                  governance of Data Protection Laws and any replacement or successor body or person
                  from time to time.
                </span>
              </li>
            </ul>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={1} type={1}>
          <ol style={{ marginTop: "0cm" }} start={2} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo86", tabStops: "list 72.0pt" }}
            >
              Any term defined in the Agreement shall have the same meaning in this Schedule.
            </li>
          </ol>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Processing of Introducer Data</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={2} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo87", tabStops: "list 72.0pt" }}
            >
              The Introducer represents and warrants to the Provider that it has all necessary
              rights to authorise the Provider to process Introducer Data in accordance with this
              Agreement and the Data Protection Laws. For the avoidance of doubt, as between the
              parties hereto, the Introducer shall bear the responsibility of providing, and shall
              to the extent required by applicable Data Protection Laws provide, fair processing
              information to relevant data subjects in respect of the processing of Introducer Data
              pursuant to this Agreement.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo87", tabStops: "list 72.0pt" }}
            >
              Throughout the duration of the Agreement the Provider may process Introducer Data on
              behalf of the Introducer for the purpose of carrying out its obligations under the
              Agreement and in order to provide the Portal. The nature of the processing is as set
              out in the Agreement. The processing shall be in respect of the Introducer's customers
              and/or employees and may include (without limitation) names, contact details, dates of
              birth and ID numbers.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo87", tabStops: "list 72.0pt" }}
            >
              The Provider shall ensure that any person employed, engaged or otherwise authorised to
              process Personal Data keeps such Personal Data confidential.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={3} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Need for written instructions</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={3} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo88", tabStops: "list 72.0pt" }}
            >
              <span style={{ msoBookmark: "_9kR3WTr29948A9DVM35tgtuwG6sepJFC60AwrN9" }}>
                <span style={{ msoBookmark: "_Ref63097999" }}>
                  Unless required to do so by Law the{" "}
                </span>
              </span>
              <span style={{ msoBookmark: "_Ref106030355" }}>
                <span style={{ msoBookmark: "_9kR3WTr29948A9DVM35tgtuwG6sepJFC60AwrN9" }}>
                  <span style={{ msoBookmark: "_Ref63097999" }}>
                    <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                      Provider shall only process Introducer Data that is Personal Data with the
                      written instructions of the Introducer, including with regards to transfers of
                      Personal Data to a third county or an international organisation.
                    </span>
                  </span>
                </span>
              </span>
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo88", tabStops: "list 72.0pt" }}
            >
              If The Provider is required to process Personal Data by Data Protection Laws without
              the written instructions of the Introducer it shall, before so processing the Personal
              Data, notify the Introducer of the legal requirement that it is subject to,{" "}
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                unless the relevant law prohibits such information on important grounds of public
                interest.
              </span>
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo88", tabStops: "list 72.0pt" }}
            >
              The entry into of the Agreement shall constitute the Introducer's written instruction
              to the Provider to operate the Portal and to process Personal Data as set out under
              the terms of the Agreement.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={4} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Sub-processing</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={4} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo89", tabStops: "list 72.0pt" }}
            >
              The Provider shall not engage another person (“a Sub-processor”) to process Introducer
              Data without written authorisation of the Introducer, whether specific to general.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo89", tabStops: "list 72.0pt" }}
            >
              In the event that the written authorisation under paragraph 4.1 is general, the
              Provider shall notify the Introducer of any intended changes concerning the addition
              or replacement of a Sub-processor at least 30 days prior to such changes. The
              Introducer shall notify the Provider of any objection to such change within 14 days of
              receipt of such notification, in which case the Provider shall not so engage the
              Sub-processor.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo89", tabStops: "list 72.0pt" }}
            >
              The Provider shall not engage a Sub-processor unless the Sub- processor is subject to
              the same contractual obligations as the Provider is under pursuant to this Schedule.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo89", tabStops: "list 72.0pt" }}
            >
              The appointment of a Sub-processor shall not remove, lessen or otherwise effect the
              Provider's obligations under this Schedule and the Provider shall be liable to the
              Introducer for the failure of the Sub-processor in the performance of its obligations.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={5} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Security of Processing</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={5} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo90", tabStops: "list 72.0pt" }}
            >
              Taking into account the state of the art, the costs of implementation and the nature,
              scope, context and purposes of processing as well as the risk of varying likelihood
              and the severity for the rights and freedoms of natural persons, both the Provider and
              the Introducer shall implement{" "}
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                appropriate technical and organisational measures in respect of the Introducer Data
                to ensure a level of security appropriate to the risk of processing Introducer Data.{" "}
              </span>
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo90", tabStops: "list 72.0pt" }}
            >
              In assessing the appropriate level of security under paragraph 5.1 above the Provider
              and the Introducer shall have regard to in particular the risks that are presented by
              processing, in particular from accidental or unlawful destruction, loss, alteration,
              unauthorised disclosure of, or access to, personal data transmitted, stored or
              otherwise processed.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo90", tabStops: "list 72.0pt" }}
            >
              Taking into account the nature of the processing under this Agreement and the
              information available to the Provider, the Provider shall assist the Introducer with
              its compliance with paragraph 5.1 above.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={6} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>The Data Subject's rights</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={6} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo91", tabStops: "list 72.0pt" }}
            >
              The Provider shall notify the Introducer if it receives any request from a Data
              Subject{" "}
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                to exercise its rights under Data Protection Laws in respect of the Introducer Data
              </span>
              .
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo91", tabStops: "list 72.0pt" }}
            >
              In the event of either party receiving a request from a Data Subject to exercise any
              rights in Chapter III of UK GDPR each party shall in so far as it is possible assist
              the other to comply with its obligations to fulfil such a request, taking into account
              the nature of the processing being carried on under the Agreement.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={7} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Personal Data Breach</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={7} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo92", tabStops: "list 72.0pt" }}
            >
              In the event of a Personal Data Breach the Provider shall notify the Introducer
              without undue delay after having become aware of it.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo92", tabStops: "list 72.0pt" }}
            >
              If the notification under paragraph 7.1 above is not made within 72 hours the Provider
              shall, when providing notification to the Introducer, state the reasons for the delay.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo92", tabStops: "list 72.0pt" }}
            >
              Any notification under paragraph 7.1 shall:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={7} type={1}>
          <ol style={{ marginTop: "0cm" }} start={3} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l3 level3 lfo93", tabStops: "list 108.0pt" }}
              >
                describe the nature of the Personal Data Breach, including where possible the
                categories and approximate number of Data Subjects concerned and the categories and
                approximate number of personal data records concerned;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l3 level3 lfo93", tabStops: "list 108.0pt" }}
              >
                communicate the name and contact details of the data protection officer or other
                contact point where more information can be obtained;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l3 level3 lfo93", tabStops: "list 108.0pt" }}
              >
                describe the likely consequences of the Personal Data Breach;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l3 level3 lfo93", tabStops: "list 108.0pt" }}
              >
                describe the measure taken or proposed to be taken to address the Personal Data
                Breach, including where appropriate, measures to mitigate its possible adverse
                effects.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={7} type={1}>
          <ol style={{ marginTop: "0cm" }} start={4} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo92", tabStops: "list 72.0pt" }}
            >
              Where it is not possible to provide the information at the same time, the information
              at paragraph 7.3 above may be provided in phases without undue further delay.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo92", tabStops: "list 72.0pt" }}
            >
              The Provider shall document any Personal Data Breach, comprising the facts relating to
              the Personal Data Breach, its effects and the remedial action taken. The Provider
              shall provide such documentation on request to the Introducer or, at either the
              Introducer's or any Supervisory Authorities' request, to the Supervisory Authority.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo92", tabStops: "list 72.0pt" }}
            >
              The Provider shall not communicate the Personal Data Breach to the Data Subject unless
              requested to do so by the Introducer or required to do so by Data Protection Laws.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={8} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Deletion of Personal Data</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={8} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo94", tabStops: "list 72.0pt" }}
            >
              At the termination of this Agreement the Provider shall, at the option of the
              Introducer, either delete or return to the Introducer all Introducer Data, and delete
              any copies of Introducer Data, unless required to store such data by Data Protection
              Laws.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo94", tabStops: "list 72.0pt" }}
            >
              Nothing in this Schedule shall prevent the Provider from retaining data for which it
              is the controller, or which it is processing on behalf of another controller,
              irrespective of whether or not this data is identical to any Introducer Data.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={9} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Audit and provision of information</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={9} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo95", tabStops: "list 72.0pt" }}
            >
              Each party shall retain records to demonstrate its compliance with this Schedule and
              shall make available to the other party such records or such other information as is
              necessary to demonstrate compliance with this Schedule and shall allow for and assist
              with any audit or inspection conducted by the other party or an auditor appointed by
              the other party.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo95", tabStops: "list 72.0pt" }}
            >
              The Provider shall immediately inform the Introducer if, in its opinion, any
              instruction from the Introducer infringes the UK GDPR or any other Data Protection
              Laws that is applicable.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Co-operation with Supervisory Authority</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={10} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo96", tabStops: "list 72.0pt" }}
            >
              Both the Provider and the Introducer shall co-operate, on request, with a Supervisory
              Authority.
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo96", tabStops: "list 72.0pt" }}
            >
              Each party shall, where requested by the other, provide assistance with any request
              made of the party by a Supervisory Authority which relates to the activities of the
              other party.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={11} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Record of processing</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={11} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo97", tabStops: "list 72.0pt" }}
            >
              The Provider shall keep a record of any processing of Introducer Data which shall
              contain at least the following information:
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={11} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <ol style={{ marginTop: "0cm" }} start={1} type={1}>
              <li
                className="MsoNormal"
                style={{ msoList: "l3 level3 lfo98", tabStops: "list 108.0pt" }}
              >
                the name and contact details of the Provider and, if applicable, The Provider's data
                protection officer;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l3 level3 lfo98", tabStops: "list 108.0pt" }}
              >
                the categories of processing carried out on behalf of the Introducer;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l3 level3 lfo98", tabStops: "list 108.0pt" }}
              >
                where applicable, transfers of personal data to a third country or an international
                organisation, including the identification of that third county or international
                organisation and, in the case of transfers referred to in the second subparagraph of
                Article 49(1) of UK GDPR, the documentation of suitable safeguards;
              </li>
              <li
                className="MsoNormal"
                style={{ msoList: "l3 level3 lfo98", tabStops: "list 108.0pt" }}
              >
                where possible, a general description of the technical and organisation security
                measures required under paragraph 5 above.
              </li>
            </ol>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={12} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>DPA impact assessments</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={12} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo99", tabStops: "list 72.0pt" }}
            >
              In the event of either party carrying out a data protection impact assessment under
              Article 35 of UK GDPR or, prior to such assessment, consulting a Supervisory Authority
              under Article 36 of UK GDPR, the other party shall assist that party in such
              assessment and/or consultation, taking into account the nature of the processing being
              carried on under this Agreement and the information available to the parties.
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={13} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Transfer of personal data outside of the EU</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={13} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo100", tabStops: "list 72.0pt" }}
            >
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                The Provider will not make a transfer outside the European Union to any third party
                without the Introducer's consent, which consent shall not be withheld, conditioned
                or delayed.
              </span>
            </li>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo100", tabStops: "list 72.0pt" }}
            >
              Where any Introducer Data that is Personal Data is transferred outside of the European
              Union by the Provider under this Agreement, including to any sub-processor, the
              Provider shall ensure that such transfer{" "}
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                complies with the{" "}
              </span>
              Data Protection Laws
              <span style={{ msoBidiFontSize: "9.0pt", lineHeight: "115%" }}>
                , including by implementing appropriate safeguards to protect such data in
                accordance with Data Protection Laws.
              </span>
            </li>
          </ol>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={14} type={1}>
          <li className="MsoNormal" style={{ msoList: "l3 level1 lfo86", tabStops: "list 36.0pt" }}>
            <b>Notice</b>
          </li>
        </ol>
        <ol style={{ marginTop: "0cm" }} start={14} type={1}>
          <ol style={{ marginTop: "0cm" }} start={1} type={1}>
            <li
              className="MsoNormal"
              style={{ msoList: "l3 level2 lfo101", tabStops: "list 72.0pt" }}
            >
              Unless this Schedule provides otherwise any notice under this Schedule shall be in
              accordance with the provisions of the Agreement.
            </li>
          </ol>
        </ol>
      </div>
    </BlankDocuments>
  </>
)

export default TermsConditions
